import React from 'react';

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import FormContainer from '../../components/AddOrEditPage/FormContainer';
import Layout from '../../containers/Layout';

import useBorrowerSettingsForm from '../../forms/borrower/borrowerSettings';
import AuthService from '../../services/AuthService';
import UserService from '../../services/UserService';
import { useUiContext } from '../../context/UiContext';

export default function BorrowerSettingsPage() {
  const queryClient = useQueryClient();

  const { showToast } = useUiContext();

  const { t, i18n } = useTranslation();

  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: AuthService.getMe,
    retry: false,
  });

  const { mutate: updateMe } = useMutation({
    mutationFn: (formValues) => {
      const values = { ...formValues };

      if (!values.password) {
        delete values.password;
        delete values.password_confirmation;
      }

      return UserService.updateMe(values);
    },
    onSuccess: () => {
      i18n.changeLanguage(i18n.language === 'en' ? 'es' : 'en');
      showToast({
        text: t('BorrowerSettingsPage.Settings updated successfully'),
        type: 'success',
      });
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text:
          error?.response?.data?.message || t('common.Something went wrong'),
        type: 'error',
      });
    },
  });

  const form = useBorrowerSettingsForm(updateMe, me);

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    {t('BorrowerSettingsPage.Settings')}
                  </h1>
                </div>
              </div>
              <div className="p-7 pt-3 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
                <FormContainer
                  form={form}
                  noBillComId
                  gridStyle="grid gap-5 md:grid-cols-1 xl:grid-cols-1"
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
